import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/postcard.css";

export default function PostRideCard({ ride }) {
  const navigate = useNavigate();

  // 🛡️ CRITICAL FIX: Stop execution if ride data is missing
  if (!ride) return null;

  // Safe Access with Optional Chaining
  const driver = ride?.postedBy || {}; 
  
  // Environment Variable for Images
  const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://192.168.29.30:5000/api";
  const SERVER_URL = API_BASE.replace("/api", ""); 

  // ✅ LOGIC FIX: Determine if the ride can still be edited
  // A ride should NOT be editable if it's already cancelled or completed.
  const canEdit = ride.status !== "cancelled" && ride.status !== "completed";

  const avatar =
    driver?.avatar && driver.avatar.startsWith("http")
      ? driver.avatar
      : driver?.avatar
      ? `${SERVER_URL}${driver.avatar}`
      : "/default-avatar.png";

  const statusClass = {
    pending: "badge-pending",
    confirmed: "badge-confirmed",
    completed: "badge-completed",
    cancelled: "badge-cancelled",
  };

  const statusText = ride?.status 
    ? ride.status.charAt(0).toUpperCase() + ride.status.slice(1) 
    : "Unknown";

  const handleCardClick = () => {
    if (ride?._id || ride?.id) {
        navigate(`/ride/${ride._id || ride.id}`);
    }
  };

  return (
    <div 
      className={`ride-card ${!canEdit ? "ride-card-inactive" : ""}`} 
      onClick={handleCardClick}
      style={{ cursor: "pointer" }}
    >
      <div className="ride-card-top">
        <img src={avatar} alt={driver?.name || "Driver"} className="ride-avatar" />
        <div className="ride-info">
          <h3 className="ride-route">{ride?.from} → {ride?.to}</h3>
          <p className="ride-driver">{driver?.name || "Driver"}</p>
          <p className="ride-datetime">
            📅 {ride?.date ? new Date(ride.date).toLocaleDateString() : "N/A"} · {ride?.time}
          </p>
        </div>
        <div className="ride-side">
          <span className={`status-badge ${statusClass[ride?.status] || "badge-pending"}`}>
            {statusText}
          </span>
          <span className="ride-price">₹{ride?.pricePerSeat}</span>
        </div>
      </div>

      <div className="ride-card-bottom">
        <p className="ride-description">{ride?.description || "No description provided."}</p>
        
        {ride?.confirmedPassengers?.length > 0 && (
          <p className="ride-passengers">👥 {ride.confirmedPassengers.length} passengers confirmed</p>
        )}

        <div className="ride-actions">
          {/* ✅ THE FIX: Only render the Edit button if canEdit is true */}
          {canEdit ? (
            <button
              className="edit-btn"
              onClick={(e) => {
                e.stopPropagation(); 
                navigate(`/ride/${ride._id || ride.id}/edit`);
              }}
            >
              ✏️ Edit Ride
            </button>
          ) : (
            <button 
              className="view-details-btn" 
              style={{ background: '#f1f5f9', color: '#64748b', border: '1px solid #cbd5e1', padding: '6px 12px', borderRadius: '8px', fontSize: '12px', fontWeight: '600' }}
            >
              View History
            </button>
          )}
        </div>
      </div>
    </div>
  );
}